<template>
  <button
    :type="props.type || 'button'"
    :disabled="props.disabled || props.loading"
    :aria-busy="props.loading"
    :aria-disabled="props.disabled || props.loading"
    role="button"
    @click="handleClick"
    :class="[baseClasses, variantClasses]"
    :aria-label="props.type || 'button'"
  >
    <template v-if="props.loading">
      <slot name="loading">
        Saving...
        <!-- default fallback -->
      </slot>
    </template>
    <template v-else>
      <slot>
        Save
      </slot>
    </template>
  </button>
</template>

<script setup lang="ts">
import { computed } from "vue";

const props = defineProps<{
  type?: "button" | "submit" | "reset";
  loading?: boolean;
  disabled?: boolean;
  variant?: "primary" | "secondary" | "danger" | "ghost";
}>();

const emit = defineEmits<{
  (e: "click", event: MouseEvent): void;
}>();

const handleClick = (e: MouseEvent) => {
  if (!props.loading && !props.disabled) {
    emit("click", e);
  }
};

const baseClasses =
  "relative flex w-full items-center justify-center border rounded-md py-2 px-8 text-sm font-medium transition-colors duration-200 shadow-md focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed";

const variantClasses = computed(() => {
  switch (props.variant) {
    case "secondary":
      return "bg-clay-950 text-clay-100 border-transparent hover:bg-clay-900 hover:text-clay-50";
    case "danger":
      return "bg-red-600 text-white border-transparent hover:bg-red-700";
    case "ghost":
      return "bg-gray-100 text-gray-900 border-transparent hover:bg-gray-200";
    case "primary":
    default:
      return "bg-electric-700 text-white border-transparent hover:bg-electric-600 ";
  }
});
</script>
